import StopePanelPage from './StopePanelPage';

export default StopePanelPage;
